import { createSelector } from 'reselect';
import { AppState } from '../reducers';

export const devicesObjectSelector = (state: AppState) => state.jiveEntities.devices;

export const devicesArraySelector = createSelector(
  devicesObjectSelector,
  (result) => (result && result.allIds.map((deviceId) => result.byId[deviceId])) || [],
);
